import styled from "styled-components";

export const Container = styled.div`
  padding: 12px 0;
  min-width: 0;
`;

export const Rail = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 12px;
  overflow-x: auto;
  padding: 0 16px;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x mandatory;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Card = styled.div`
  flex: 0 0 min(400px, calc(100% - 8px));
  min-width: 260px;
  scroll-snap-align: start;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #fff;
  border: 1px solid #d8d8d8;
  border-radius: 16px;
  padding: 12px;
  gap: 12px;
  box-shadow: none;
`;

export const Icon = styled.img`
  width: 28px;
  height: 28px;
  object-fit: contain;
  flex-shrink: 0;
`;

export const TextCol = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #000;
  margin-bottom: 4px;
`;

export const Subtitle = styled.div`
  font-size: 12px;
  color: #757575;
  line-height: 1.35;
`;
